export default __webpack_public_path__ + "static/media/blog02.5cc22842.jpg";